<template>
  <!--
    Newsroom search — lives in the dark nav (S9). A dark search pill opens a
    white panel holding the remote NewsroomSearch (HfSelect); selecting a
    newsroom navigates to its stories. The nav has no clipping ancestor, so the
    inline-absolute HfSelect dropdown escapes the panel fine (S8 clipping note).
  -->
  <div
    v-click-away="clickedAway"
    class="NewsroomSearchDropdown relative"
  >
    <button
      ref="trigger"
      type="button"
      data-testid="NewsroomSearchDropdownTrigger"
      class="flex cursor-pointer items-center gap-2 rounded-full border-none bg-white/10 px-4 text-sm text-white/70 transition-colors hover:bg-white/15 hover:text-white"
      :class="isActive ? 'h-9 bg-white/15 text-white' : 'h-9'"
      @click.prevent="toggleOpen"
    >
      <i class="hf hf-search hf-fw" />
      <span class="hidden lg:inline">{{ $t('components.story_search.search_newsroom') }}</span>
    </button>

    <div
      v-show="isActive"
      class="absolute right-0 z-40 mt-2 w-80 overflow-visible rounded-card border border-solid border-line bg-surface p-4 shadow-lg"
    >
      <h5 class="mb-3 font-display text-sm font-bold uppercase tracking-wide text-muted-soft">
        {{ $t('components.company_search.find_newsroom') }}
      </h5>

      <newsroomSearch
        ref="newsroomSearch"
        size="small"
        @change="handleChange"
      />
    </div>
  </div>
</template>

<script>
import newsroomSearch from '@/components/storySearch/NewsroomSearch'

export default {
  components: {
    newsroomSearch
  },

  data () {
    return {
      isActive: false
    }
  },

  methods: {
    toggleOpen () {
      this.isActive = !this.isActive
      if (this.isActive) this.$refs.newsroomSearch.focusSelect()
    },

    clickedAway (e) {
      if (this.$refs.trigger && this.$refs.trigger.contains(e.target)) return
      this.isActive = false
    },

    handleChange (selected) {
      this.isActive = false
      this.$router.push({
        name: 'newsroom.stories',
        params: { newsroomSlug: selected.slug }
      })
    }
  }
}
</script>
